import {createSelector} from 'reselect';
import {getSelectedDeliveryCountryOnPaymentResolutionPage} from './PaymentResolutionSelectors';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, getSelectedDeliveryCountryOnPaymentResolutionPage],
  (settings, country) => !!settings.should_pass_name_code_for_state_if_available?.includes(country),
);
